/**
 * Phương pháp tính thuế GTGT
 * NHANH3 14.05.2024
 */
export default {
  DeductionMethod: 0,
  DirectMethod: 1,
};